import { UAParser } from "ua-parser-js";

const parser = new UAParser();
export const useDeviceInfo = () => {
  const result = parser.getResult();
  return {
    ...result,
    device: {
      ...result.device,
      // For standard desktop devices, the type is not set, so we default to desktop
      type: result.device.type ?? "desktop",
    },
  };
};
